import React, { useEffect, useState, useContext } from 'react';
import { Link } from "react-router-dom";
import Layout from '../../parts/Layout';
import { httpRequest } from '../../../services/httpService';
import helpers from '../../../services/helpers';
import Swal from 'sweetalert2';
import Loader from '../../parts/Loader';
import Dropdown from 'react-bootstrap/Dropdown'
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import initTreeView from '../../../services/initTreeView';
import FormContext from '../../../services/formContext';
import { getApiData } from '../../../services/apiService';
import { CiShare1 } from "react-icons/ci";
import { FaInfoCircle } from "react-icons/fa";
import EmployeesFormModal from '../../app/hr/EmployeesFormModal';

export default function UsersList ({viewer = 'admin', menu = 'users', page_title = "Manage Users"}){
    const {
        account
    } = useContext(FormContext);
    //const default_currency = helpers.getSettingValue(account?.settings, 'default_currency', 'PHP');

    const [record_data, setRecordData] = useState([]);
    const [loading, setLoading] = useState(1);
    const [search_key, setSearchKey] = useState('');
    const [data_table, setDataTable] = useState([]);
    const [selected_items, setSelectedItems] = useState([]);
    const [reference_id, setReferenceID] = useState('');
    const [show_modal, setShowModal] = useState(0);
    const [datatable_state, setDataTableState] = useState({
        first: 0,
        rows: 10,
        page: 0,
        sortField: null,
        sortOrder: null
    });

    useEffect(() => {
        initTreeView()
        fetchDataList({
            "page": datatable_state.page + 1,
            "per_page": datatable_state.rows
        })
    }, []);

    useEffect(() => {
        displayDataTable(record_data)
    }, [datatable_state.sortOrder]);

    useEffect(() => {
        displayDataTable(record_data)
    }, [
        selected_items
    ]);

    useEffect(() => {
        fetchDataList({
            "page": datatable_state.page + 1,
            "per_page": datatable_state.rows,
            "search": search_key
        })
    }, [datatable_state]);

    async function fetchDataList(condition = {
        "page": '',
        "search": '',
        "per_page": ''
    }){
        const page = condition.page ?? datatable_state.page
        const per_page = condition.per_page ?? datatable_state.rows
        const search = condition.search ?? search_key
        let filter = `?paginate=1&`

        if(page){
            filter += 'page='+page+'&'
        }
        if(per_page){
            filter += 'per_page='+per_page+'&'
        }
        if(search){
            filter += 'search='+search+'&'
        }

        filter = filter.slice(0, -1)

        setLoading(1)

        let endpoint = helpers.createUrl(`V1/users${filter}`)
        // setLoading(1)
        const res = await getApiData(endpoint, false)

        if(res.status === 'error'){
            Swal.fire({
                title: "Error!",
                text: res.message,
                icon: "error",
                confirmButtonText: "OK",
            });
            setLoading(0)
        }
        else{
            setRecordData(res)
            setLoading(0)
            displayDataTable(res)
        }
    }
    
    function search(e){
        let { value } = e.target;
        setSearchKey(value)
        fetchDataList({
            "page": datatable_state.page + 1,
            "search": value
        })
    }

    function triggerAction(data = '', action = '', status = ''){
        let ids = [];
        if(action === 'single-delete'){
            ids.push(data.id)
        }
        else{
            ids = data.map(o => o['id']);
        }

        let title = 'Delete User'
        if(ids.length > 1){
            title = 'Delete Users'
        }

        Swal.fire({
            title: title,
            text: 'This action cannot be reversed. All associated records will also be deleted. Do you want to continue?',
            showCancelButton: true,
            showConfirmButton: false,
            closeOnCancel: true,
            showDenyButton: true,
            denyButtonText: 'Yes'
        })
        .then((result) => {
            if (result.isDenied) {
                deleteItem(ids)
            }
        })
    }

    function deleteItem(id){
        const url = helpers.createUrl('V1/users/delete')
        httpRequest(url, 'POST', {
            postdata: {
                "ids": id
            },
        }, true)
            .then((res) => {
                setLoading(0)
                fetchDataList({
                    "page": datatable_state.page + 1,
                    "per_page": datatable_state.rows,
                    "search": search_key
                })
                setSelectedItems([])

                Swal.fire({
                    title: "Success",
                    text: res.message,
                    icon: "success",
                    confirmButtonText: "OK",
                })
            })
            .catch((err) => {
                console.log(err)
                setLoading(0)
                setSelectedItems([])

                Swal.fire({
                    text: err.message,
                    //text: err.message,
                    icon: "error",
                    confirmButtonText: "OK",
                })
            }); 
    }

    function displayDataTable(data){
        setDataTable(
            <DataTable 
                className='border-top'
                dataKey={data.id}
                value={data.data} 
                // tableStyle={{ minWidth: '50rem' }}
                size="normal"
                paginator 
                rows={data.per_page} 
                rowsPerPageOptions={[5, 10, 20, 25, 50]}
                totalRecords={data.total}
                onPage={onPage}
                first={datatable_state.first}
                lazy
                currentPageReportTemplate="{first} to {last} of {totalRecords}"
                selection={selected_items} 
                onSelectionChange={onSelectItem}
                scrollHeight="500px"
                scrollable
                responsive={true}
                emptyMessage="No data to display"
            >
                <Column selectionMode="multiple" headerStyle={{ width: '3rem' }} />
                <Column field="display_name" header="NAME" ></Column>
                <Column field="email" header="EMAIL" ></Column>
                <Column header="ROLE" body={({role_name}) => role_name ? role_name : '---' }/>
                <Column header="LINKED PROFILE" body={({entity_type, reference_id}) => {
                    if(entity_type === 'employee'){
                        return <Link onClick={() => {
                                        setShowModal(1)
                                        setReferenceID(reference_id)
                                    }
                                }><FaInfoCircle /> Employee</Link>
                    }
                    else if(entity_type === 'vendor'){
                        return <Link to={`/vendors/${reference_id}/edit`}><FaInfoCircle/> Vendor</Link>
                    }
                    else{
                        return 'NONE';
                    }
                }}/>
                <Column className="text-right" body={displayActionMenu} style={{ maxWidth: '50px' }}></Column> 
            </DataTable>
        )

    }

    const onPage = (e) => {
        setDataTableState(e)
        setSelectedItems([])
    };

    const onSelectItem = (e) => {
        const value = e.value;
        setSelectedItems(value);
    };

    function displayActionMenu(data){
        return (<Dropdown>
                        <Dropdown.Toggle className='btn-light border' size="sm" id={"dropdown-actions-"+data.id}>Action</Dropdown.Toggle>
                        <Dropdown.Menu align="end">
                            <Dropdown.Item key="edit" as={Link} to={`/account/users/${data.id}/edit`}><i className="fas fa-pencil-alt mr-2" />Edit</Dropdown.Item>
                            <Dropdown.Divider />
                            <Dropdown.Item key="delete" className='text-danger' onClick={(e) => triggerAction(data, 'single-delete')}><i className="fas fa-trash mr-2" />Delete</Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>)
    }

    function handleSave(){
        //fetchDataList()
    }

    return (
        <>
        <EmployeesFormModal 
            show_modal={show_modal} 
            close_modal={setShowModal} 
            handleSave={handleSave}
            id={reference_id}
        />
        <Layout page_title={page_title} menu={menu} parent_text="Account">
            <div className="container-fluid" style={{position: 'relative'}}>
                <Loader isLoading={loading}/>
                <div className="row">
                    <div className="col-12">
                        <div className="card">
                            <div className="card-header border-bottom-0">
                                <div className="row">
                                    <div className="col-lg-4">
                                        <input type="text" className="form-control" placeholder="Search" onChange={search} />
                                    </div>
                                    <div className="col-lg-8 text-right mt-3 mt-md-0">
                                        <Link className='btn btn-primary float-right' to="/account/users/new"><i className="fas fa-plus-circle mr-2" />New</Link>
                                
                                        {selected_items.length ?
                                        <Dropdown className='float-right mr-3'>
                                            <Dropdown.Toggle className='btn-light border' id={"dropdown-actions-"}>Bulk Action</Dropdown.Toggle>
                                            <Dropdown.Menu align="end">
                                                <Dropdown.Item key="delete" className='text-danger' onClick={(e) => triggerAction(selected_items)}><i className="fas fa-trash mr-2" />Delete</Dropdown.Item>
                                            </Dropdown.Menu>
                                        </Dropdown> : ''}
                                    </div>
                                </div>
                            </div>
                            <div className="card-body p-0">
                                { data_table }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
        </>
    )
}